import { render, staticRenderFns } from "./packlist.vue?vue&type=template&id=c41a5ad0&scoped=true&"
import script from "./packlist.vue?vue&type=script&lang=js&"
export * from "./packlist.vue?vue&type=script&lang=js&"
import style0 from "./packlist.vue?vue&type=style&index=0&id=c41a5ad0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41a5ad0",
  null
  
)

export default component.exports